{
  "version": 1,
  "asset_id": "0ce6f6ff-330e-4bf8-9a9b-846a26ae9627",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/0ce6f6ff-330e-4bf8-9a9b-846a26ae9627/cert-ctpat.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/0ce6f6ff-330e-4bf8-9a9b-846a26ae9627/cert-ctpat.webp",
  "original_filename": "cert-ctpat.webp",
  "size": 9476,
  "content_type": "image/webp",
  "created_at": "2026-09-22T12:21:28Z"
}
